/**
 * Functionality specific to the public portal.
 */
(async () => {
  // In the homepage, show link to the internal portal.
  const internalPortalButton = document.getElementById("internal-portal-banner");
  if (internalPortalButton) {
    try {
      const response = await fetch("/_auth/me");
      if (response.ok) {
        const userInfo = await response.json();
        if (userInfo?.email && /@siemens.com$/.test(userInfo.email)) {
          internalPortalButton.style.display = "block";
        }
      }
    } catch {
      // do nothing
    }
  }
})();
